import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllUser = createAsyncThunk(
  "user/GetAllUser",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}user?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleUser = createAsyncThunk(
  "user/GetSingleUser",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}user/get_by_id/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateUser = createAsyncThunk(
  "user/CreateUser",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}user`,
        {
          username: data.username,
          nama: data.nama,
          email: data.email,
          id_fakultas: data.id_fakultas,
          id_prodi: data.id_prodi,
          nip: data.nip,
          id_role: data.id_role,
          password: data.password,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteUser = createAsyncThunk(
  "user/EditUser",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(`${api}user/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });

      if (responseDelete.data.success) {
        listData = await axios.get(`${api}user?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all user
    builder.addCase(GetAllUser.pending, loadingHandler);
    builder.addCase(GetAllUser.fulfilled, fulfilledHandler);
    builder.addCase(GetAllUser.rejected, rejectedHandler);
    // get single user
    builder.addCase(GetSingleUser.pending, loadingHandler);
    builder.addCase(GetSingleUser.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleUser.rejected, rejectedHandler);
    // create user
    builder.addCase(CreateUser.pending, loadingHandler);
    builder.addCase(CreateUser.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateUser.rejected, rejectedHandler);
    // delete user
    builder.addCase(DeleteUser.pending, loadingHandler);
    builder.addCase(DeleteUser.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteUser.rejected, rejectedHandler);
  },
});

export const { reset } = userSlice.actions;
export default userSlice.reducer;
